 const COLORS = {
    white: '#fff',
    black: '#000',
    // DEARhealth brand — the logo pairs a petrol "teal" with an "orange" accent.
    orangepeel: '#ff9803',
    orangeDark: '#e07f00',
    orangeLight: '#ffb64d',
    teal: '#0c6e91',
    tealDark: '#08536e',
    tealLight: '#178cb4',
    carmine: '#B04645',
    // Neutral ramp used across surfaces, borders and text.
    canvas: '#f6f7f9',
    surface: '#ffffff',
    border: '#e6e8ec',
    ink: '#111827',
    inkMuted: '#6b7280',
}

export default COLORS;
